// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface INMVITSBrand {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class NMVITSBrand implements INMVITSBrand, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Flood Damage NMVITSBrand
	**/
    get FloodDamage(): INMVITSBrand {
        return this.FromId(1);
    }
    /**
		Returns Fire Damage NMVITSBrand
	**/
    get FireDamage(): INMVITSBrand {
        return this.FromId(2);
    }
    /**
		Returns Hail Damage NMVITSBrand
	**/
    get HailDamage(): INMVITSBrand {
        return this.FromId(3);
    }
    /**
		Returns Saltwater Damage NMVITSBrand
	**/
    get SaltwaterDamage(): INMVITSBrand {
        return this.FromId(4);
    }
    /**
		Returns Vandalism NMVITSBrand
	**/
    get Vandalism(): INMVITSBrand {
        return this.FromId(5);
    }
    /**
		Returns Kit NMVITSBrand
	**/
    get Kit(): INMVITSBrand {
        return this.FromId(6);
    }
    /**
		Returns Dismantled NMVITSBrand
	**/
    get Dismantled(): INMVITSBrand {
        return this.FromId(7);
    }
    /**
		Returns Junk NMVITSBrand
	**/
    get Junk(): INMVITSBrand {
        return this.FromId(8);
    }
    /**
		Returns Rebuilt NMVITSBrand
	**/
    get Rebuilt(): INMVITSBrand {
        return this.FromId(9);
    }
    /**
		Returns Reconstructed NMVITSBrand
	**/
    get Reconstructed(): INMVITSBrand {
        return this.FromId(10);
    }
    /**
		Returns Salvage - Damage or Not Specified NMVITSBrand
	**/
    get SalvageDamageorNotSpecified(): INMVITSBrand {
        return this.FromId(11);
    }
    /**
		Returns Test Vehicle NMVITSBrand
	**/
    get TestVehicle(): INMVITSBrand {
        return this.FromId(12);
    }
    /**
		Returns Refurbished NMVITSBrand
	**/
    get Refurbished(): INMVITSBrand {
        return this.FromId(13);
    }
    /**
		Returns Collision NMVITSBrand
	**/
    get Collision(): INMVITSBrand {
        return this.FromId(14);
    }
    /**
		Returns Salvage Retention NMVITSBrand
	**/
    get SalvageRetention(): INMVITSBrand {
        return this.FromId(16);
    }
    /**
		Returns Prior Taxi NMVITSBrand
	**/
    get PriorTaxi(): INMVITSBrand {
        return this.FromId(17);
    }
    /**
		Returns Prior Police NMVITSBrand
	**/
    get PriorPolice(): INMVITSBrand {
        return this.FromId(18);
    }
    /**
		Returns Original Taxi NMVITSBrand
	**/
    get OriginalTaxi(): INMVITSBrand {
        return this.FromId(19);
    }
    /**
		Returns Original Police NMVITSBrand
	**/
    get OriginalPolice(): INMVITSBrand {
        return this.FromId(20);
    }
    /**
		Returns Remanufactured NMVITSBrand
	**/
    get Remanufactured(): INMVITSBrand {
        return this.FromId(21);
    }
    /**
		Returns Gray Market NMVITSBrand
	**/
    get GrayMarket(): INMVITSBrand {
        return this.FromId(22);
    }
    /**
		Returns Warranty Return NMVITSBrand
	**/
    get WarrantyReturn(): INMVITSBrand {
        return this.FromId(23);
    }
    /**
		Returns Antique NMVITSBrand
	**/
    get Antique(): INMVITSBrand {
        return this.FromId(24);
    }
    /**
		Returns Classic NMVITSBrand
	**/
    get Classic(): INMVITSBrand {
        return this.FromId(25);
    }
    /**
		Returns Agricultural Vehicle NMVITSBrand
	**/
    get AgriculturalVehicle(): INMVITSBrand {
        return this.FromId(26);
    }
    /**
		Returns Logging Vehicle NMVITSBrand
	**/
    get LoggingVehicle(): INMVITSBrand {
        return this.FromId(27);
    }
    /**
		Returns Stree tRod NMVITSBrand
	**/
    get StreetRod(): INMVITSBrand {
        return this.FromId(28);
    }
    /**
		Returns Vehicle Contains Reissued VIN NMVITSBrand
	**/
    get VehicleContainsReissuedVIN(): INMVITSBrand {
        return this.FromId(29);
    }
    /**
		Returns Replica NMVITSBrand
	**/
    get Replica(): INMVITSBrand {
        return this.FromId(30);
    }
    /**
		Returns Totaled NMVITSBrand
	**/
    get Totaled(): INMVITSBrand {
        return this.FromId(31);
    }
    /**
		Returns Owner Retained	 NMVITSBrand
	**/
    get OwnerRetained(): INMVITSBrand {
        return this.FromId(32);
    }
    /**
		Returns Bond Posted NMVITSBrand
	**/
    get BondPosted(): INMVITSBrand {
        return this.FromId(33);
    }
    /**
		Returns MemorandumC opy NMVITSBrand
	**/
    get MemorandumCopy(): INMVITSBrand {
        return this.FromId(34);
    }
    /**
		Returns Parts Only NMVITSBrand
	**/
    get PartsOnly(): INMVITSBrand {
        return this.FromId(35);
    }
    /**
		Returns Recovered Theft NMVITSBrand
	**/
    get RecoveredTheft(): INMVITSBrand {
        return this.FromId(36);
    }
    /**
		Returns Undisclosed Lien NMVITSBrand
	**/
    get UndisclosedLien(): INMVITSBrand {
        return this.FromId(37);
    }
    /**
		Returns Prior Owner Retained NMVITSBrand
	**/
    get PriorOwnerRetained(): INMVITSBrand {
        return this.FromId(38);
    }
    /**
		Returns VehNon-conformityUncorrected NMVITSBrand
	**/
    get VehNonconformityUncorrected(): INMVITSBrand {
        return this.FromId(39);
    }
    /**
		Returns VehNon-conformityCorrected NMVITSBrand
	**/
    get VehNonconformityCorrected(): INMVITSBrand {
        return this.FromId(40);
    }
    /**
		Returns VehSafetyDefectUncorrected NMVITSBrand
	**/
    get VehSafetyDefectUncorrected(): INMVITSBrand {
        return this.FromId(41);
    }
    /**
		Returns VehSafetyDefectCorrected NMVITSBrand
	**/
    get VehSafetyDefectCorrected(): INMVITSBrand {
        return this.FromId(42);
    }
    /**
		Returns VIN Replaced by State Assigned VIN NMVITSBrand
	**/
    get VINReplacedbyStateAssignedVIN(): INMVITSBrand {
        return this.FromId(43);
    }
    /**
		Returns GrayMarket Non-compliant NMVITSBrand
	**/
    get GrayMarketNoncompliant(): INMVITSBrand {
        return this.FromId(45);
    }
    /**
		Returns GrayMarket Compliant NMVITSBrand
	**/
    get GrayMarketCompliant(): INMVITSBrand {
        return this.FromId(46);
    }
    /**
		Returns Manufacturer Buy Back NMVITSBrand
	**/
    get ManufacturerBuyBack(): INMVITSBrand {
        return this.FromId(47);
    }
    /**
		Returns Former Rental NMVITSBrand
	**/
    get FormerRental(): INMVITSBrand {
        return this.FromId(48);
    }
    /**
		Returns Salvage - Stolen NMVITSBrand
	**/
    get SalvageStolen(): INMVITSBrand {
        return this.FromId(49);
    }
    /**
		Returns SalvageReason <> Damage/Stolen NMVITSBrand
	**/
    get SalvageReasonDamageStolen(): INMVITSBrand {
        return this.FromId(50);
    }
    /**
		Returns DisclosedDamage NMVITSBrand
	**/
    get DisclosedDamage(): INMVITSBrand {
        return this.FromId(51);
    }
    /**
		Returns Prior Non-Repairable/Repaired NMVITSBrand
	**/
    get PriorNonRepairableRepaired(): INMVITSBrand {
        return this.FromId(52);
    }
    /**
		Returns Crushed NMVITSBrand
	**/
    get Crushed(): INMVITSBrand {
        return this.FromId(53);
    }
    /**
		Returns Inoperable Vehicle NMVITSBrand
	**/
    get InoperableVehicle(): INMVITSBrand {
        return this.FromId(54);
    }
    /**
		Returns Hazardous Substance Contaminated Vehicle NMVITSBrand
	**/
    get HazardousSubstanceContaminatedVehicle(): INMVITSBrand {
        return this.FromId(55);
    }
    /**
		Returns Actual NMVITSBrand
	**/
    get Actual(): INMVITSBrand {
        return this.FromId(68);
    }
    /**
		Returns NotActual NMVITSBrand
	**/
    get NotActual(): INMVITSBrand {
        return this.FromId(69);
    }
    /**
		Returns Not Actual - Odometer Tampering Verified NMVITSBrand
	**/
    get NotActualOdometerTamperingVerified(): INMVITSBrand {
        return this.FromId(70);
    }
    /**
		Returns Exempt - Odometer Disclosure NMVITSBrand
	**/
    get ExemptOdometerDisclosure(): INMVITSBrand {
        return this.FromId(71);
    }
    /**
		Returns ExceedsMechanicalLimits NMVITSBrand
	**/
    get ExceedsMechanicalLimits(): INMVITSBrand {
        return this.FromId(72);
    }
    /**
		Returns OdometermaybeAltered NMVITSBrand
	**/
    get OdometermaybeAltered(): INMVITSBrand {
        return this.FromId(73);
    }
    /**
		Returns Odometer Replaced NMVITSBrand
	**/
    get OdometerReplaced(): INMVITSBrand {
        return this.FromId(74);
    }
    /**
		Returns Reading at Time of Renewal NMVITSBrand
	**/
    get ReadingatTimeofRenewal(): INMVITSBrand {
        return this.FromId(75);
    }
    /**
		Returns Odometer Discrepancy NMVITSBrand
	**/
    get OdometerDiscrepancy(): INMVITSBrand {
        return this.FromId(76);
    }
    /**
		Returns Call Title Division NMVITSBrand
	**/
    get CallTitleDivision(): INMVITSBrand {
        return this.FromId(77);
    }
    /**
		Returns Rectify Prev ExceedsMechanicalLimits NMVITSBrand
	**/
    get RectifyPrevExceedsMechanicalLimits(): INMVITSBrand {
        return this.FromId(78);
    }
    /**
		Returns Pending JunkAutomobile NMVITSBrand
	**/
    get PendingJunkAutomobile(): INMVITSBrand {
        return this.FromId(90);
    }
    /**
		Returns JunkAutomobile NMVITSBrand
	**/
    get JunkAutomobile(): INMVITSBrand {
        return this.FromId(91);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'FloodDamage', displayValue: 'Flood Damage', description: 'FloodDamage', sortOrder: 9999, active: true });
        this._dictionary.add('2', { id: 2, value: 'FireDamage', displayValue: 'Fire Damage', description: 'Fire Damage', sortOrder: 9999, active: true });
        this._dictionary.add('3', { id: 3, value: 'HailDamage', displayValue: 'Hail Damage', description: 'Hail Damage', sortOrder: 9999, active: true });
        this._dictionary.add('4', { id: 4, value: 'SaltwaterDamage', displayValue: 'Saltwater Damage', description: 'Saltwater Damage', sortOrder: 9999, active: true });
        this._dictionary.add('5', { id: 5, value: 'Vandalism', displayValue: 'Vandalism', description: 'Vandalism', sortOrder: 9999, active: true });
        this._dictionary.add('6', { id: 6, value: 'Kit', displayValue: 'Kit', description: 'Kit', sortOrder: 9999, active: true });
        this._dictionary.add('7', { id: 7, value: 'Dismantled', displayValue: 'Dismantled', description: 'Dismantled', sortOrder: 9999, active: true });
        this._dictionary.add('8', { id: 8, value: 'Junk', displayValue: 'Junk', description: 'Junk', sortOrder: 9999, active: true });
        this._dictionary.add('9', { id: 9, value: 'Rebuilt', displayValue: 'Rebuilt', description: 'Rebuilt', sortOrder: 9999, active: true });
        this._dictionary.add('10', { id: 10, value: 'Reconstructed', displayValue: 'Reconstructed', description: 'Reconstructed', sortOrder: 9999, active: true });
        this._dictionary.add('11', { id: 11, value: 'Salvage-Damage or Not Specified', displayValue: 'Salvage - Damage or Not Specified', description: 'Salvage -- Damage or Not Specified', sortOrder: 9999, active: true });
        this._dictionary.add('12', { id: 12, value: 'TestVehicle', displayValue: 'Test Vehicle', description: 'TestVehicle', sortOrder: 9999, active: true });
        this._dictionary.add('13', { id: 13, value: 'Refurbished', displayValue: 'Refurbished', description: 'Refurbished', sortOrder: 9999, active: true });
        this._dictionary.add('14', { id: 14, value: 'Collision', displayValue: 'Collision', description: 'Collision', sortOrder: 9999, active: true });
        this._dictionary.add('16', { id: 16, value: 'SalvageRetention', displayValue: 'Salvage Retention', description: 'SalvageRetention', sortOrder: 9999, active: true });
        this._dictionary.add('17', { id: 17, value: 'PriorTaxi', displayValue: 'Prior Taxi', description: 'PriorTaxi', sortOrder: 9999, active: true });
        this._dictionary.add('18', { id: 18, value: 'PriorPolice', displayValue: 'Prior Police', description: 'PriorPolice', sortOrder: 9999, active: true });
        this._dictionary.add('19', { id: 19, value: 'OriginalTaxi', displayValue: 'Original Taxi', description: 'OriginalTaxi', sortOrder: 9999, active: true });
        this._dictionary.add('20', { id: 20, value: 'OriginalPolice', displayValue: 'Original Police', description: 'OriginalPolice', sortOrder: 9999, active: true });
        this._dictionary.add('21', { id: 21, value: 'Remanufactured', displayValue: 'Remanufactured', description: 'Remanufactured', sortOrder: 9999, active: true });
        this._dictionary.add('22', { id: 22, value: 'Gray Market', displayValue: 'Gray Market', description: 'Gray Market', sortOrder: 9999, active: true });
        this._dictionary.add('23', { id: 23, value: 'WarrantyReturn', displayValue: 'Warranty Return', description: 'WarrantyReturn', sortOrder: 9999, active: true });
        this._dictionary.add('24', { id: 24, value: 'Antique', displayValue: 'Antique', description: 'Antique', sortOrder: 9999, active: true });
        this._dictionary.add('25', { id: 25, value: 'Classic', displayValue: 'Classic', description: 'Classic', sortOrder: 9999, active: true });
        this._dictionary.add('26', { id: 26, value: 'AgriculturalVehicle', displayValue: 'Agricultural Vehicle', description: 'AgriculturalVehicle', sortOrder: 9999, active: true });
        this._dictionary.add('27', { id: 27, value: 'LoggingVehicle', displayValue: 'Logging Vehicle', description: 'LoggingVehicle', sortOrder: 9999, active: true });
        this._dictionary.add('28', { id: 28, value: 'StreetRod', displayValue: 'Stree tRod', description: 'StreetRod', sortOrder: 9999, active: true });
        this._dictionary.add('29', { id: 29, value: 'VehicleContainsReissuedVIN', displayValue: 'Vehicle Contains Reissued VIN', description: 'VehicleContainsReissuedVIN', sortOrder: 9999, active: true });
        this._dictionary.add('30', { id: 30, value: 'Replica', displayValue: 'Replica', description: 'Replica', sortOrder: 9999, active: true });
        this._dictionary.add('31', { id: 31, value: 'Totaled', displayValue: 'Totaled', description: 'Totaled', sortOrder: 9999, active: true });
        this._dictionary.add('32', { id: 32, value: 'OwnerRetained', displayValue: 'Owner Retained	', description: 'OwnerRetained', sortOrder: 9999, active: true });
        this._dictionary.add('33', { id: 33, value: 'BondPosted', displayValue: 'Bond Posted', description: 'BondPosted', sortOrder: 9999, active: true });
        this._dictionary.add('34', { id: 34, value: 'MemorandumCopy', displayValue: 'MemorandumC opy', description: 'MemorandumCopy', sortOrder: 9999, active: true });
        this._dictionary.add('35', { id: 35, value: 'PartsOnly', displayValue: 'Parts Only', description: 'PartsOnly', sortOrder: 9999, active: true });
        this._dictionary.add('36', { id: 36, value: 'RecoveredTheft', displayValue: 'Recovered Theft', description: 'RecoveredTheft', sortOrder: 9999, active: true });
        this._dictionary.add('37', { id: 37, value: 'UndisclosedLien', displayValue: 'Undisclosed Lien', description: 'UndisclosedLien', sortOrder: 9999, active: true });
        this._dictionary.add('38', { id: 38, value: 'PriorOwnerRetained', displayValue: 'Prior Owner Retained', description: 'PriorOwnerRetained', sortOrder: 9999, active: true });
        this._dictionary.add('39', { id: 39, value: 'VehNon-conformityUncorrected', displayValue: 'VehNon-conformityUncorrected', description: 'VehNon-conformityUncorrected', sortOrder: 9999, active: true });
        this._dictionary.add('40', { id: 40, value: 'VehNon-conformityCorrected', displayValue: 'VehNon-conformityCorrected', description: 'VehNon-conformityCorrected', sortOrder: 9999, active: true });
        this._dictionary.add('41', { id: 41, value: 'VehSafetyDefectUncorrected', displayValue: 'VehSafetyDefectUncorrected', description: 'VehSafetyDefectUncorrected', sortOrder: 9999, active: true });
        this._dictionary.add('42', { id: 42, value: 'VehSafetyDefectCorrected', displayValue: 'VehSafetyDefectCorrected', description: 'VehSafetyDefectCorrected', sortOrder: 9999, active: true });
        this._dictionary.add('43', { id: 43, value: 'VIN Replaced by State Assigned VIN', displayValue: 'VIN Replaced by State Assigned VIN', description: 'VIN Replaced by State Assigned VIN', sortOrder: 9999, active: true });
        this._dictionary.add('45', { id: 45, value: 'GrayMarketNon-compliant', displayValue: 'GrayMarket Non-compliant', description: 'GrayMarketNon-compliant', sortOrder: 9999, active: true });
        this._dictionary.add('46', { id: 46, value: 'GrayMarketCompliant', displayValue: 'GrayMarket Compliant', description: 'GrayMarketCompliant', sortOrder: 9999, active: true });
        this._dictionary.add('47', { id: 47, value: 'ManufacturerBuyBack', displayValue: 'Manufacturer Buy Back', description: 'ManufacturerBuyBack', sortOrder: 9999, active: true });
        this._dictionary.add('48', { id: 48, value: 'FormerRental', displayValue: 'Former Rental', description: 'FormerRental', sortOrder: 9999, active: true });
        this._dictionary.add('49', { id: 49, value: 'Salvage-Stolen', displayValue: 'Salvage - Stolen', description: 'Salvage -- Stolen', sortOrder: 9999, active: true });
        this._dictionary.add('50', { id: 50, value: 'SalvageReason<>Damage/Stolen', displayValue: 'SalvageReason <> Damage/Stolen', description: 'SalvageReason<>Damage/Stolen', sortOrder: 9999, active: true });
        this._dictionary.add('51', { id: 51, value: 'DisclosedDamage', displayValue: 'DisclosedDamage', description: 'DisclosedDamage', sortOrder: 9999, active: true });
        this._dictionary.add('52', { id: 52, value: 'PriorNon-Repairable/Repaired', displayValue: 'Prior Non-Repairable/Repaired', description: 'PriorNon-Repairable/Repaired', sortOrder: 9999, active: true });
        this._dictionary.add('53', { id: 53, value: 'Crushed', displayValue: 'Crushed', description: 'Crushed', sortOrder: 9999, active: true });
        this._dictionary.add('54', { id: 54, value: 'InoperableVehicle', displayValue: 'Inoperable Vehicle', description: 'InoperableVehicle', sortOrder: 9999, active: true });
        this._dictionary.add('55', { id: 55, value: 'Hazardous Substance Contaminated Vehicle', displayValue: 'Hazardous Substance Contaminated Vehicle', description: 'Hazardous Substance Contaminated Vehicle', sortOrder: 9999, active: true });
        this._dictionary.add('68', { id: 68, value: 'Actual', displayValue: 'Actual', description: 'Actual', sortOrder: 9999, active: true });
        this._dictionary.add('69', { id: 69, value: 'NotActual', displayValue: 'NotActual', description: 'NotActual', sortOrder: 9999, active: true });
        this._dictionary.add('70', { id: 70, value: 'Not Actual-OdometerTamperingVerified', displayValue: 'Not Actual - Odometer Tampering Verified', description: 'Not Actual - OdometerTamperingVerified', sortOrder: 9999, active: true });
        this._dictionary.add('71', { id: 71, value: 'Exempt:OdometerDisclosure', displayValue: 'Exempt - Odometer Disclosure', description: 'Exempt:OdometerDisclosure', sortOrder: 9999, active: true });
        this._dictionary.add('72', { id: 72, value: 'ExceedsMechanicalLimits', displayValue: 'ExceedsMechanicalLimits', description: 'ExceedsMechanicalLimits', sortOrder: 9999, active: true });
        this._dictionary.add('73', { id: 73, value: 'OdometermaybeAltered', displayValue: 'OdometermaybeAltered', description: 'OdometermaybeAltered', sortOrder: 9999, active: true });
        this._dictionary.add('74', { id: 74, value: 'OdometerReplaced', displayValue: 'Odometer Replaced', description: 'OdometerReplaced', sortOrder: 9999, active: true });
        this._dictionary.add('75', { id: 75, value: 'ReadingatTimeofRenewal', displayValue: 'Reading at Time of Renewal', description: 'ReadingatTimeofRenewal', sortOrder: 9999, active: true });
        this._dictionary.add('76', { id: 76, value: 'OdometerDiscrepancy', displayValue: 'Odometer Discrepancy', description: 'OdometerDiscrepancy', sortOrder: 9999, active: true });
        this._dictionary.add('77', { id: 77, value: 'CallTitleDivision', displayValue: 'Call Title Division', description: 'CallTitleDivision', sortOrder: 9999, active: true });
        this._dictionary.add('78', { id: 78, value: 'RectifyPrevExceedsMechanicalLimits', displayValue: 'Rectify Prev ExceedsMechanicalLimits', description: 'RectifyPrevExceedsMechanicalLimits', sortOrder: 9999, active: true });
        this._dictionary.add('90', { id: 90, value: 'PendingJunkAutomobile', displayValue: 'Pending JunkAutomobile', description: 'PendingJunkAutomobile', sortOrder: 9999, active: true });
        this._dictionary.add('91', { id: 91, value: 'JunkAutomobile', displayValue: 'JunkAutomobile', description: 'JunkAutomobile', sortOrder: 9999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): INMVITSBrand {
        return this._dictionary[id];
    }

    public FromValue(value: string): INMVITSBrand {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): INMVITSBrand[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): INMVITSBrand[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): INMVITSBrand[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
